import { storableError } from '../../util/errors';
import { fetchSeoVenuesIndex } from '../../util/seoDiscoveryFetch';
import {
  VENUE_INDEX_PAGE_SIZE,
  letterFromParam,
  parseIndexPageParam,
} from '../../util/seoDiscoveryIndexLetters';

export const FETCH_LETTER_REQUEST = 'app/SeoDiscoveryVenuesLetterPage/FETCH_REQUEST';
export const FETCH_LETTER_SUCCESS = 'app/SeoDiscoveryVenuesLetterPage/FETCH_SUCCESS';
export const FETCH_LETTER_ERROR = 'app/SeoDiscoveryVenuesLetterPage/FETCH_ERROR';

const initialState = {
  data: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LETTER_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_LETTER_SUCCESS:
      return { ...state, fetchInProgress: false, data: payload };
    case FETCH_LETTER_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchLetterIndex = ({ letter, page }) => dispatch => {
  dispatch({ type: FETCH_LETTER_REQUEST });
  const offset = (page - 1) * VENUE_INDEX_PAGE_SIZE;
  return fetchSeoVenuesIndex({
    launched: 'true',
    sort: 'name',
    letter,
    limit: String(VENUE_INDEX_PAGE_SIZE),
    offset: String(offset),
  })
    .then(data =>
      dispatch({
        type: FETCH_LETTER_SUCCESS,
        payload: { ...data, page },
      })
    )
    .catch(e => dispatch({ type: FETCH_LETTER_ERROR, payload: storableError(e) }));
};

export const loadData = params => dispatch => {
  const letter = letterFromParam(params?.letter);
  if (!letter) {
    return Promise.resolve();
  }
  const page = parseIndexPageParam(params?.page);
  return dispatch(fetchLetterIndex({ letter, page }));
};
